<template>
  <div id="o-site">
    <v-card
      elevation="2"
      class="pa-3"
    >
      <v-form
        v-model="valid"
        ref="form"
      >
        <PageTitle
          main="Administração"
          icon="mdi-pencil-box-outline"
          sub="Cadastro geral de grupo de páginas do site"
          home="/administracao"
        />
        <input
          id="user-id"
          type="hidden"
          v-model="pagina.usuario"
        />
        <input
          id="pagina-id"
          type="hidden"
          v-model="pagina.id"
        />
        <input
          id="pagina-uuid"
          type="hidden"
          v-model="pagina.uuid"
        />
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="pagina.id"
              label="Código"
              outlined
              dense
            >
              <v-icon
                slot="append"
                color="success"
                large
                @click="loadDialog"
              >
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="pagina.modulo"
              label="Módulo da pagina"
              outlined
              required
              dense
              hint="Name do menu na rota; Ex.: home"
              persistent-hint
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="pagina.nome_modulo"
              label="Nome do módulo"
              outlined
              required
              dense
              hint="Nome do menu da página; Ex.: Início"
              persistent-hint
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="8"
          >
            <v-text-field
              v-model="pagina.titulo"
              label="Título"
              outlined
              required
              dense
              hint="Nome que vaai aparecer no topo da página"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="8"
          >
            <v-textarea
              v-model="pagina.subtitulo"
              label="Subtítulo"
              auto-grow
              outlined
              rows="3"
              row-height="25"
              dense
              hint="Descrição que pode dizer algo sobre a página ou no menu"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-card>
          <v-tabs
            v-model="tabs"
            height="45"
          >
            <v-tab>
              <v-icon class="mr-2">
                mdi-note-text
              </v-icon>
              Texto
            </v-tab>
            <v-tab :disabled="!pagina.id">
              <v-icon class="mr-2">
                mdi-settings
              </v-icon>
              Configurações
            </v-tab>
            <v-tab
              @click="loadBreads"
              :disabled="!pagina.id"
            >
              <v-icon class="mr-2">
                mdi-view-list
              </v-icon>
              Breadcrumbs
            </v-tab>
            <v-tab
              @click="loadMenus"
              :disabled="!pagina.id"
            >
              <v-icon class="mr-2">
                mdi-menu
              </v-icon>
              Menus
            </v-tab>
            <v-tab
              @click="loadLinks"
              :disabled="!pagina.id"
            >
              <v-icon class="mr-2">
                mdi-link
              </v-icon>
              Links
            </v-tab>
            <v-tab
              @click="loadDocs"
              :disabled="!pagina.id"
            >
              <v-icon class="mr-2">
                mdi-paperclip
              </v-icon>
              Arquivos
            </v-tab>
            <v-tab
              @click="loadMidias"
              :disabled="!pagina.id"
            >
              <v-icon class="mr-2">
                mdi-camera
              </v-icon>
              Midias
            </v-tab>
            <v-tab
              @click="loadPubConteudo()"
              :disabled="!pagina.id"
            >
              <v-icon class="mr-2">
                mdi-eye
              </v-icon>
              Publicação
            </v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card class="pa-2">
                      <ckeditor
                        :editor="editor"
                        v-model="pagina.html"
                        :config="editorConfig"
                      ></ckeditor>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                    v-if="pagina.id"
                  >
                    <v-checkbox
                      v-model="pagina.inativar"
                      label="Inativar Página ?"
                      color="success"
                      v-show="mode === 'save'"
                    >
                    </v-checkbox>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-checkbox
                      v-model="pagina.link_externo"
                      label="Página externa ?"
                      color="success"
                      hide-details
                      v-show="mode === 'save'"
                    >
                    </v-checkbox>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-checkbox
                      v-model="pagina.menu"
                      label="Possui menu ?"
                      color="success"
                      hide-details
                      v-show="mode === 'save'"
                    >
                    </v-checkbox>
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-checkbox
                      v-model="pagina.breadcrumbs"
                      label="Possui breadcrumbs ?"
                      color="success"
                      hide-details
                      v-show="mode === 'save'"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="5"
                    lg="3"
                  >
                    <v-text-field
                      v-model="pagina.icon"
                      label="Ícone do título"
                      outlined
                      required
                      dense
                      v-if="mode === 'save'"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                    lg="3"
                  >
                    <v-text-field
                      v-model="pagina.color"
                      label="Cor para o ícone e título"
                      outlined
                      required
                      dense
                      v-if="mode === 'save'"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    lg="9"
                    md="8"
                  >
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          md="10"
                        >
                          <v-text-field
                            v-model="pagina.link"
                            label="Url da página"
                            outlined
                            required
                            dense
                            v-if="mode === 'save'"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          md="2"
                        >
                          <v-autocomplete
                            v-model="pagina.target_url"
                            :items="targets"
                            required
                            dense
                            outlined
                            label="Target"
                          >
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          md="12"
                        >
                          <v-text-field
                            v-model="pagina.url_imagem"
                            label="Url da imagem"
                            outlined
                            required
                            dense
                            v-if="mode === 'save'"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="3"
                    md="4"
                  >
                    <v-card>
                      <v-img :src="pagina.url_imagem"></v-img>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-card-title>
                        Breadcrumbs
                      </v-card-title>
                      <v-data-table
                        :headers="headersBread"
                        :items="breads"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadBread(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadBread(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-4 mb-2"
                            v-if="pagina.id"
                            @click="loadAddBread"
                          >
                            <v-icon left>
                              mdi-view-list
                            </v-icon>
                            Breadcrumbs
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-card-title>
                        Menus da pagina
                      </v-card-title>
                      <v-data-table
                        :headers="headersMenu"
                        :items="menus"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            v-if="item.inativar === 1"
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadActiveMenu(item)"
                          >
                            mdi-eye-off-outline
                          </v-icon>
                          <v-icon
                            v-else
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadInactiveMenu(item)"
                          >
                            mdi-eye-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="delMenu(item)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-4 mb-2"
                            v-if="pagina.id"
                            @click="loadAddMenu"
                          >
                            <v-icon left>
                              mdi-view-list
                            </v-icon>
                            Menu
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-card-title>
                        Links da pagina
                      </v-card-title>
                      <v-data-table
                        :headers="headersLink"
                        :items="links"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadLink(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadLink(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-4 mb-2"
                            v-if="pagina.id"
                            @click="loadAddLink"
                          >
                            <v-icon left>
                              mdi-plus
                            </v-icon>
                            Links
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-card-title>
                        Arquivos
                      </v-card-title>
                      <v-data-table
                        :headers="headersDoc"
                        :items="docs"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadDoc(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadDoc(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-4 mb-2"
                            v-if="pagina.id"
                            @click="loadAddDoc"
                          >
                            <v-icon left>
                              mdi-view-list
                            </v-icon>
                            Arquivos
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-card-title>
                        Fotos ou videos
                      </v-card-title>
                      <v-data-table
                        :headers="headersMid"
                        :items="midias"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadUrl(item)"
                          >
                            mdi-upload-network
                          </v-icon>
                          <v-icon
                            medium
                            color="primary"
                            class="mr-2"
                            @click="loadMid(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                          <v-icon
                            medium
                            color="error"
                            class="mr-2"
                            @click="loadMid(item, 'remove')"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-4 mb-2"
                            v-if="pagina.id"
                            @click="loadAddMid"
                          >
                            <v-icon left>
                              mdi-camera
                            </v-icon>
                            Midias
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <v-row class="mt-4">
          <v-col
            cols="12"
            md="10"
          >
            <v-btn
              :disabled="!valid"
              color="success"
              class="mr-4"
              v-if="mode === 'save'"
              @click="save"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4"
              v-if="mode === 'remove'"
              @click="remove"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Deletar
            </v-btn>
            <v-btn
              color="secondary"
              class="mr-4"
              @click="reset"
            >
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="dialog"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar páginas
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="paginas"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      medium
                      color="primary"
                      class="mr-2"
                      @click="loadPagina(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                    <v-icon
                      medium
                      color="error"
                      class="mr-2"
                      @click="loadPagina(item, 'remove')"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialog.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-container>
        <v-dialog
          v-model="addDoc"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Adicionar arquivos anexo
              </v-toolbar>
              <v-card
                elevation="2"
                class="pa-3"
              >
                <div class="ma-5">
                  <PageTitle
                    main=""
                    icon="mdi-pencil-box-outline"
                    sub="Documento em anexo da página"
                    home=""
                  />
                  <v-form>
                    <input
                      id="user-id"
                      type="hidden"
                      v-model="doc.usuario"
                    />
                    <input
                      id="doc-id"
                      type="hidden"
                      v-model="doc.id"
                    />
                    <input
                      id="doc-uuid"
                      type="hidden"
                      v-model="doc.uid_pagina"
                    />
                    <input
                      id="uid_boletim"
                      type="hidden"
                      v-model="doc.uuid_pagina"
                    />
                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-text-field
                          v-model="pagina.id"
                          label="Código"
                          dense
                          filled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="pagina.id"
                      >
                        <v-checkbox
                          v-model="doc.inativar"
                          label="Inativar arquivo?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-menu
                          v-model="menu6"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-mask="datanex"
                              v-model="data_anex"
                              label="Data de publicacao.:"
                              dense
                              outlined
                              @blur="mudaDataG"
                            >
                              <v-icon
                                slot="append"
                                color="success"
                                large
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            locale="pt-br"
                            v-model="date6"
                            @input="dateG"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <input
                        accept="application/vnd.ms-excel, application/vnd.ms-word, application/pdf"
                        prepend-icon="mdi-paperclip"
                        label="Documento"
                        v-if="uploadReady"
                        type="file"
                        ref="file"
                        @change="selectFile()"
                      >
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="pagina.id"
                    type="submit"
                    @click.prevent="docUpload()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn
                    color="error"
                    class="mr-4"
                    v-if="pagina.id"
                    @click="clearUpload"
                  >
                    Remover
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="addMidia"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Adicionar Imagens ou videos
              </v-toolbar>
              <v-card
                elevation="2"
                class="pa-3"
              >
                <div class="ma-5">
                  <PageTitle
                    main=""
                    icon="mdi-pencil-box-outline"
                    sub="Imagens ou videos da página"
                    home=""
                  />
                  <v-form>
                    <input
                      id="user-id"
                      type="hidden"
                      v-model="midia.usuario"
                    />
                    <input
                      id="doc-id"
                      type="hidden"
                      v-model="midia.id"
                    />
                    <input
                      id="midia-uuid"
                      type="hidden"
                      v-model="midia.uid_pagina"
                    />
                    <input
                      id="uid_boletim"
                      type="hidden"
                      v-model="midia.uuid_pagina"
                    />
                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-text-field
                          v-model="pagina.id"
                          label="Código"
                          dense
                          filled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="midia.id"
                      >
                        <v-checkbox
                          v-model="midia.inativar"
                          label="Inativar mídia?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-menu
                          v-model="menu2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-mask="datamid"
                              v-model="data_mid"
                              label="Data de publicacao.:"
                              dense
                              outlined
                              @blur="mudaDataA"
                            >
                              <v-icon
                                slot="append"
                                color="success"
                                large
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            locale="pt-br"
                            v-model="date2"
                            @input="dateA"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <input
                        accept="image/png, image/jpg, image/jpeg, image/bmp"
                        prepend-icon="mdi-camera"
                        label="Arquivo de imagem ou video"
                        v-if="uploadReady"
                        type="file"
                        ref="file"
                        @change="selectFile()"
                      >
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="pagina.id"
                    type="submit"
                    @click.prevent="fileUpload()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn
                    color="error"
                    class="mr-4"
                    v-if="pagina.id"
                    @click="clearUpload"
                  >
                    Remover
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <!-- Módulo de menus da página-->
      <v-container>
        <v-dialog
          v-model="addMenus"
          transition="dialog-top-transition"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Menus da página
            </v-toolbar>
            <v-card
              elevation="2"
              class="pa-3"
            >
              <div class="ma-5">
                <PageTitle
                  icon="mdi-pencil-box-outline"
                  sub="Menus da página"
                />
                <v-form>
                  <input
                    id="user-id"
                    type="hidden"
                    v-model="menupagina.usuario"
                  />
                  <input
                    id="uid_pagina"
                    type="hidden"
                    v-model="menupagina.uid_pagina"
                  />
                  <input
                    id="id_menu"
                    type="hidden"
                    v-model="menupagina.id_menu"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="codeMenu"
                        label="Código"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      v-if="codeMenu.id"
                    >
                      <v-checkbox
                        v-model="menupagina.inativar"
                        label="Inativar menu ?"
                        color="success"
                        class="mt-0 mb-2"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-autocomplete
                        v-model="gruponome"
                        :items="grupoMenu"
                        label="Grupo de menus"
                        clearable
                        outlined
                        dense
                        @change="loadSubMenuSite()"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-autocomplete
                        v-model="menunome"
                        :items="subMenu"
                        label="Subgrupo do menu"
                        clearable
                        outlined
                        dense
                        @change="loadMenuSite()"
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-autocomplete
                        v-model="menupagina.uid_menu"
                        :items="parentMenu"
                        label="Nome"
                        clearable
                        outlined
                        dense
                        @change="loadMenuAdd()"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-text-field
                        v-model="menupagina.chave"
                        label="Chave"
                        outlined
                        required
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="7"
                    >
                      <v-text-field
                        v-model="menupagina.menu"
                        label="Menu"
                        outlined
                        required
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="10"
                    >
                      <v-text-field
                        v-model="menupagina.ds_menu"
                        label="Descrição"
                        outlined
                        required
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="pagina.id"
                  type="submit"
                  @click="addSairMenu"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar e sair
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="pagina.id"
                  type="submit"
                  @click="addContMenu"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar e continuar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="pagina.id"
                  @click="resetMenu"
                >
                  Limpar
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="closeDialogMenu()"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-dialog>
      </v-container>
      <!-- módulo de breadcrumbs da página-->
      <v-container>
        <v-dialog
          v-model="addBread"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Adicionar breadcrumbs
              </v-toolbar>
              <v-card
                elevation="2"
                class="pa-3"
              >
                <div class="ma-5">
                  <PageTitle
                    icon="mdi-pencil-box-outline"
                    sub="Breadcrumbs da página"
                  />
                  <v-form>
                    <input
                      id="user-id"
                      type="hidden"
                      v-model="bread.usuario"
                    />
                    <input
                      id="uuid_page"
                      type="hidden"
                      v-model="bread.uuid_page"
                    />
                    <input
                      id="uid_page"
                      type="hidden"
                      v-model="bread.uid_page"
                    />
                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-text-field
                          v-model="pagina.id"
                          label="Código"
                          dense
                          filled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="pagina.id"
                      >
                        <v-checkbox
                          v-model="bread.inativar"
                          label="Inativar breadcrumb ?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="pagina.id"
                      >
                        <v-checkbox
                          v-model="bread.disabled"
                          label="Desabilitar link ?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="pagina.id"
                      >
                        <v-text-field
                          v-model="bread.text"
                          label="Nome"
                          outlined
                          required
                          dense
                          v-if="mode === 'save'"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="pagina.id"
                      >
                        <v-text-field
                          v-model="bread.href"
                          label="link"
                          outlined
                          required
                          dense
                          v-if="mode === 'save'"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="codigo"
                    type="submit"
                    @click="addSair"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar e sair
                  </v-btn>
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="codigo"
                    type="submit"
                    @click="addCont"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar e continuar
                  </v-btn>
                  <v-btn
                    color="error"
                    class="mr-4"
                    v-if="codigo"
                    @click="resetBread"
                  >
                    Limpar
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="addLink"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Adicionar links
              </v-toolbar>
              <v-card
                elevation="2"
                class="pa-3"
              >
                <div class="ma-5">
                  <PageTitle
                    icon="mdi-pencil-box-outline"
                    sub="Links da página"
                  />
                  <v-form>
                    <input
                      id="link-id"
                      type="hidden"
                      v-model="link.id"
                    />
                    <input
                      id="user-id"
                      type="hidden"
                      v-model="link.usuario"
                    />
                    <input
                      id="uuid"
                      type="hidden"
                      v-model="link.uuid"
                    />
                    <input
                      id="uuid_page"
                      type="hidden"
                      v-model="link.uuid_page"
                    />
                    <input
                      id="uid_page"
                      type="hidden"
                      v-model="link.uid_page"
                    />
                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-text-field
                          v-model="pagina.id"
                          label="Código"
                          dense
                          filled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="link.id"
                      >
                        <v-checkbox
                          v-model="link.inativar"
                          label="Inativar link ?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="5"
                      >
                        <v-autocomplete
                          v-model="link.uid_categoria"
                          :items="categorias"
                          required
                          dense
                          outlined
                          label="Categoria"
                          @change="loadSubCategorias()"
                          v-if="mode === 'save'"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        md="5"
                      >
                        <v-autocomplete
                          v-model="link.uid_subcategoria"
                          :items="subcategorias"
                          required
                          dense
                          outlined
                          label="Subcategoria"
                          :disabled="!link.uid_categoria"
                          v-if="mode === 'save'"
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="10"
                        v-if="pagina.id"
                      >
                        <v-text-field
                          v-model="link.titulo"
                          label="Título"
                          outlined
                          required
                          dense
                          v-if="mode === 'save'"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="10"
                        v-if="pagina.id"
                      >
                        <v-text-field
                          v-model="link.subtitulo"
                          label="Subtítulo"
                          outlined
                          required
                          dense
                          v-if="mode === 'save'"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="10"
                      >
                        <v-text-field
                          v-model="link.link"
                          label="Link de destino"
                          outlined
                          required
                          dense
                          v-if="mode === 'save'"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-checkbox
                          v-model="link.link_externo"
                          label="Link externo ?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-autocomplete
                          v-model="link.target"
                          :items="targets"
                          required
                          dense
                          outlined
                          label="Target"
                          :disabled="!link.link_externo"
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="codigo"
                    type="submit"
                    @click="addLinkSair"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar e sair
                  </v-btn>
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="codigo"
                    type="submit"
                    @click="addLinkCont"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar e continuar
                  </v-btn>
                  <v-btn
                    color="error"
                    class="mr-4"
                    v-if="codigo"
                    @click="resetLink"
                  >
                    Limpar
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="publicar"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Publicar conteúdo
              </v-toolbar>
              <v-card
                elevation="2"
                class="pa-3"
              >
                <div class="ma-5">
                  <PageTitle
                    main=""
                    icon="mdi-pencil-box-outline"
                    sub="Publicar página no site"
                    home=""
                  />
                  <v-form>
                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-text-field
                          v-model="codigo"
                          label="Código"
                          dense
                          filled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="pagina.id"
                      >
                        <v-checkbox
                          v-model="pagina.publicar"
                          label="Publicar conteúdo?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-menu
                          v-model="menu5"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-mask="datapub"
                              v-model="data_pub"
                              label="Data de publicacao.:"
                              dense
                              outlined
                              @blur="mudaDataF"
                            >
                              <v-icon
                                slot="append"
                                color="success"
                                large
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            locale="pt-br"
                            v-model="date5"
                            @input="dateF"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="pagina.id"
                    type="submit"
                    @click="pubConteudo()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn
                    color="error"
                    class="mr-4"
                    v-if="pagina.id"
                    @click="resetNode"
                  >
                    Limpar
                    <v-icon left>
                      mdi-broom
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="editBread"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Atualizar breadcrumb
              </v-toolbar>
              <v-card
                elevation="2"
                class="pa-3"
              >
                <div class="ma-5">
                  <PageTitle
                    icon="mdi-pencil-box-outline"
                    sub="Atualizar breadcrumb"
                  />
                  <v-form>
                    <input
                      id="bread-id"
                      type="hidden"
                      v-model="bread.id"
                    />
                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-text-field
                          v-model="pagina.id"
                          label="Código"
                          dense
                          filled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="pagina.id"
                      >
                        <v-checkbox
                          v-model="bread.inativar"
                          label="Inativar breadcrumb ?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="pagina.id"
                      >
                        <v-checkbox
                          v-model="bread.disabled"
                          label="Desabilitar link ?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="pagina.id"
                      >
                        <v-text-field
                          v-model="bread.text"
                          label="Nome"
                          outlined
                          required
                          dense
                          v-if="mode === 'save'"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="pagina.id"
                      >
                        <v-text-field
                          v-model="bread.href"
                          label="link"
                          outlined
                          required
                          dense
                          v-if="mode === 'save'"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="pagina.id"
                    type="submit"
                    @click="saveBread()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn
                    color="error"
                    class="mr-4"
                    v-if="pagina.id"
                    @click="undoBread"
                  >
                    Desfazer
                    <v-icon left>
                      mdi-undo
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="editDoc"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Atualizar Arquivos
              </v-toolbar>
              <v-card
                elevation="2"
                class="pa-3"
              >
                <div class="ma-5">
                  <PageTitle
                    icon="mdi-pencil-box-outline"
                    sub="Atualizar arquivos"
                  />
                  <v-form>
                    <input
                      id="bread-id"
                      type="hidden"
                      v-model="bread.id"
                    />
                    <v-row>
                      <v-col
                        cols="12"
                        md="2"
                      >
                        <v-text-field
                          v-model="pagina.id"
                          label="Código"
                          dense
                          filled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="pagina.id"
                      >
                        <v-checkbox
                          v-model="bread.inativar"
                          label="Inativar breadcrumb ?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="pagina.id"
                      >
                        <v-checkbox
                          v-model="bread.disabled"
                          label="Desabilitar link ?"
                          color="success"
                          class="mt-0 mb-2"
                          v-show="mode === 'save'"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="pagina.id"
                      >
                        <v-text-field
                          v-model="bread.text"
                          label="Nome"
                          outlined
                          required
                          dense
                          v-if="mode === 'save'"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        v-if="pagina.id"
                      >
                        <v-text-field
                          v-model="bread.href"
                          label="link"
                          outlined
                          required
                          dense
                          v-if="mode === 'save'"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="pagina.id"
                    type="submit"
                    @click="saveBread()"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Salvar
                  </v-btn>
                  <v-btn
                    color="error"
                    class="mr-4"
                    v-if="pagina.id"
                    @click="undoBread"
                  >
                    Desfazer
                    <v-icon left>
                      mdi-undo
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="vincFoto"
          transition="dialog-top-transition"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Vincular url de mídia à pagina
              </v-toolbar>
              <v-card
                elevation="2"
                class="pa-3"
              >
                <div class="ma-5">
                  <PageTitle
                    icon="mdi-pencil-box-outline"
                    sub="Imagem de destaque da página"
                  />
                  <v-form>
                    <v-row>
                      <v-col
                        cols="12"
                        lg="9"
                        md="8"
                      >
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="url.url_imagem"
                                clearable
                                label="Url da imagem"
                                outlined
                                required
                                dense
                                v-if="mode === 'save'"
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="12"
                              md="2"
                            >
                              <v-text-field
                                v-model="codigo"
                                label="Código"
                                dense
                                filled
                              >
                              </v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="2"
                              v-if="pagina.id"
                            >
                              <v-checkbox
                                v-model="url.img_vinculada"
                                label="Vincular url?"
                                color="success"
                                class="mt-0 mb-2"
                                v-show="mode === 'save'"
                              >
                              </v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-col>
                      <v-col
                        cols="12"
                        lg="3"
                        md="4"
                      >
                        <v-card>
                          <v-img :src="url.url_imagem">
                          </v-img>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-form>
                </div>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="mr-4"
                    v-if="pagina.id"
                    @click="addImagemCapa()"
                  >
                    <v-icon left>
                      mdi-autorenew
                    </v-icon>
                    Sinconizar
                  </v-btn>
                  <v-btn
                    color="danger"
                    class="mr-4"
                    @click="dialog.value = false"
                  >
                    Sair
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
// import { VueEditor } from 'vue2-editor'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { baseApiUrl, showError } from '@/global'
import moment from 'moment'
import axios from 'axios'
export default {
  name: 'OSite',
  components: { PageTitle },
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    editor: ClassicEditor,
    editorConfig: {},
    datapub: '##/##/####',
    datanex: '##/##/####',
    datamid: '##/##/####',
    tabs: null,
    codigo: '',
    codeMenu: '',
    dialog: false,
    addBread: false,
    addMenus: false,
    addDoc: false,
    addMidia: false,
    addLink: false,
    publicar: false,
    editBread: false,
    editDoc: false,
    vincFoto: false,
    uploadReady: true,
    date2: new Date().toISOString().substr(0, 10),
    date5: new Date().toISOString().substr(0, 10),
    data_publicacao: '',
    menu: false,
    menu2: false,
    menu5: false,
    menu6: false,
    data_pub: '',
    data_anex: '',
    data_mid: '',
    file: '',
    gruponome: '',
    menunome: '',
    tabela: 'paginamidias',
    tabela_doc: 'paginanexos',
    search: '',
    mode: 'save',
    pagina: {},
    not: {},
    paginas: [],
    publico: {},
    bread: {},
    breads: [],
    link: {},
    links: [],
    menus: [],
    menupagina: {},
    categorias: [],
    subcategorias: [],
    imagem: {},
    capa: {},
    doc: {},
    docs: [],
    midia: {},
    url: {},
    foto: {},
    midias: [],
    length: '',
    grupoMenu: [],
    subMenu: [],
    parentMenu: [],
    targets: [
      { value: '_top', text: '_top' },
      { value: '_self', text: '_self' },
      { value: '_blank', text: '_blank' }
    ],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Título', value: 'titulo' },
      { text: 'Módulo', value: 'modulo' },
      { text: 'Nome do módulo', value: 'nome_modulo' },
      {
        text: 'Breadcrumb',
        value: 'breadcrumbs',
        sortable: false,
        formatter: value => value ? 'Ativo' : 'Inativo'
      },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Ativo' : 'Inativo'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersMenu: [
      {
        text: 'Código',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'menu' },
      { text: 'Observação', value: 'ds_menu' },
      { text: 'Posição', value: 'posicao' },
      { text: 'Situação', value: 'status', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersBread: [
      {
        text: 'Código',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'text' },
      { text: 'Caminho', value: 'href' },
      {
        text: 'Inativo?',
        value: 'disabled',
        sortable: false
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersLink: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Título', value: 'titulo' },
      { text: 'Link', value: 'link' },
      {
        text: 'Link interno',
        value: 'link_externo',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      {
        text: 'Ativo',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersDoc: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Url', value: 'url' },
      { text: 'Tam Arq.', value: 'size' },
      { text: 'Data', value: 'publicacao' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersMid: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Url', value: 'url' },
      { text: 'Tam Arq.', value: 'size' },
      { text: 'Data', value: 'publicacao' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    valid: false
  }),
  methods: {
    getHtml () {
      let html = this.$refs.toastuiEditor.invoke('getHtml')
      this.pagina.html = html
    },
    mudaDataA () {
      const [dia, mes, ano] = this.data_mid.split('/')
      this.midia.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateA () {
      this.data_mid = moment(this.date2).format('DD/MM/YYYY')
      this.menu2 = false
      const [dia, mes, ano] = this.data_mid.split('/')
      this.midia.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateF () {
      this.data_pub = moment(this.date5).format('DD/MM/YYYY')
      this.menu5 = false
      const [dia, mes, ano] = this.data_pub.split('/')
      this.pagina.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataF () {
      const [dia, mes, ano] = this.data_pub.split('/')
      this.pagina.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateG () {
      this.data_anex = moment(this.date6).format('DD/MM/YYYY')
      this.menu6 = false
      const [dia, mes, ano] = this.data_anex.split('/')
      this.doc.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataG () {
      const [dia, mes, ano] = this.data_anex.split('/')
      this.doc.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    validate () {
      this.$refs.form.validate()
    },
    save () {
      const method = this.pagina.id ? 'put' : 'post'
      const id = this.pagina.id ? `/${this.pagina.id}` : ''
      axios[method](`${baseApiUrl}/paginas-param${id}`, this.pagina)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadUpdate()
        })
        .catch(showError)
    },
    saveBread () {
      const method = this.bread.id ? 'put' : 'post'
      const id = this.bread.id ? `/${this.bread.id}` : ''
      axios[method](`${baseApiUrl}/bread-param${id}`, this.bread)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetBread()
          this.loadBreads()
        })
        .catch(showError)
    },
    saveMenu () {
      const method = this.menupagina.id ? 'put' : 'post'
      const id = this.menupagina.id ? `/${this.menupagina.id}` : ''
      axios[method](`${baseApiUrl}/menus-de-paginas-param${id}`, this.menupagina)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetMenu()
          this.loadMenus()
        })
        .catch(showError)
    },
    delMenu (item) {
      const method = 'delete'
      const id = item.id
      axios[method](`${baseApiUrl}/menus-de-paginas-param/${id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadMenus()
        })
        .catch(showError)
    },
    saveDoc () {
      const method = this.doc.id ? 'put' : 'post'
      const id = this.doc.id ? `/${this.doc.id}` : ''
      axios[method](`${baseApiUrl}/doc-param${id}`, this.doc)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetDoc()
          this.loadDocs()
        })
        .catch(showError)
    },
    addImagemCapa () {
      const id = this.pagina.uuid
      axios.put(`${baseApiUrl}/add-img-capa-pagina/${id}`, this.url)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadPagina()
        })
        .catch(showError)
    },
    saveLink () {
      const method = this.link.id ? 'put' : 'post'
      const id = this.link.id ? `/${this.link.id}` : ''
      axios[method](`${baseApiUrl}/link-param${id}`, this.link)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetLink()
          this.loadLinks()
        })
        .catch(showError)
    },
    pubConteudo () {
      this.publico.data_publicacao = this.pagina.data_publicacao
      this.publico.publicar = this.pagina.publicar
      const id = this.pagina.uuid
      axios.put(`${baseApiUrl}/publicar-pagina/${id}`, this.publico)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetNode()
          this.loadUpdate()
          this.publicar = false
        })
        .catch(showError)
    },
    editImagem () {
      this.imagem.data_publicacao_img = this.date1
      const id = this.foto.uuid
      axios.put(`${baseApiUrl}/editar-imagem/${id}`, this.imagem)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.midia = {}
          this.loadMidias()
          this.editBread = false
        })
        .catch(showError)
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const url = `${baseApiUrl}/upload-de-midia-da-pagina`
      formData.append('uuid_pagina', this.midia.uuid_pagina)
      formData.append('uid_pagina', this.midia.uid_pagina)
      formData.append('data_publicacao', this.midia.data_publicacao)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.pagina.id)
      formData.append('nome', this.midia.nome)
      formData.append('usuario', this.midia.usuario)
      formData.append('file', this.file)
      await axios.post(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadMidias()
          this.resetUpload()
        })
        .catch(showError)
    },
    async docUpload () {
      const formData = new FormData()
      const url = `${baseApiUrl}/upload-anexos-diversos`
      formData.append('uuid_pagina', this.doc.uuid_pagina)
      formData.append('uid_pagina', this.doc.uid_pagina)
      formData.append('data_publicacao', this.doc.data_publicacao)
      formData.append('tabela', this.tabela_doc)
      formData.append('pasta', this.pagina.id)
      formData.append('nome', this.doc.nome)
      formData.append('usuario', this.doc.usuario)
      formData.append('file', this.file)
      await axios.post(url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadDocs()
          this.resetUpload()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    resetUpload () {
      this.file = ''
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
      this.resetMidia()
      this.resetDoc()
    },
    remove () {
      alert('Deseja realmente remover?')
    },
    loadPaginas () {
      const url = `${baseApiUrl}/paginas-param-pai`
      axios.get(url).then(res => {
        this.paginas = res.data
      })
    },
    loadMidias () {
      const idm = this.pagina.id
      const url = `${baseApiUrl}/midias-da-pagina/${idm}`
      axios.get(url).then(res => {
        this.midias = res.data.map(item => {
          return {
            ...item,
            publicacao: moment(item.data_publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadBreads () {
      const idB = this.pagina.id
      const url = `${baseApiUrl}/breadcrumb-por-pagina/${idB}`
      axios.get(url).then(res => {
        this.breads = res.data
      })
    },
    loadMenus () {
      const idB = this.pagina.id
      const url = `${baseApiUrl}/menus-de-paginas-param/${idB}`
      axios.get(url).then(res => {
        this.menus = res.data.map(item => {
          return {
            ...item,
            status: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadLinks () {
      const idB = this.pagina.id
      const url = `${baseApiUrl}/links-por-pagina/${idB}`
      axios.get(url).then(res => {
        this.links = res.data
      })
    },
    loadPagina (pagina, mode = 'save') {
      this.mode = mode
      const id = pagina.id
      const url = `${baseApiUrl}/paginas-param/${id}`
      axios.get(url).then(res => {
        this.pagina = res.data
      })
      this.codigo = id
      this.dialog = false
      this.valid = true
    },
    clearUpdate () {
      this.pagina = {}
      this.codigo = ''
    },
    loadUpdate (mode = 'save') {
      this.mode = mode
      this.codigo = this.pagina.id
      const id = this.pagina.id ? `/${this.pagina.id}` : ''
      const url = `${baseApiUrl}/paginas-por-ultimo-id${id}`
      this.clearUpdate()
      axios.get(url).then(res => {
        this.pagina = res.data
      })
    },
    loadUrl (foto, mode = 'save') {
      this.mode = mode
      this.foto = { ...foto }
      this.url.url_imagem = this.foto.url
      this.url.img_vinculada = true
      this.vincFoto = true
    },
    loadCategorias () {
      const url = `${baseApiUrl}/categorias`
      axios.get(url).then(res => {
        this.categorias = res.data.map(cat => {
          return {
            value: cat.id,
            text: cat.categoria
          }
        })
      })
    },
    loadSubCategorias () {
      const uidCat = this.link.uid_categoria
      const url = `${baseApiUrl}/subcategorias-da-categoria/${uidCat}`
      axios.get(url).then(res => {
        this.subcategorias = res.data.map(subcat => {
          return {
            value: subcat.id,
            text: subcat.categoria
          }
        })
      })
    },
    loadDocs () {
      const idCd = this.pagina.id
      const url = `${baseApiUrl}/arquivos-por-pagina/${idCd}`
      axios.get(url).then(res => {
        this.docs = res.data.map(item => {
          return {
            ...item,
            publicacao: moment(item.data_publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadDoc (doc, mode = 'save') {
      this.mode = mode
      const idDc = doc.id
      const url = `${baseApiUrl}/doc-param/${idDc}`
      axios.get(url).then(res => {
        this.doc = res.data
      })
      this.editDoc = true
    },
    loadMid (doc, mode = 'save') {
      this.mode = mode
      const idDc = doc.id
      const url = `${baseApiUrl}/doc-param/${idDc}`
      axios.get(url).then(res => {
        this.doc = res.data
      })
      this.editDoc = true
    },
    loadBread (bread, mode = 'save') {
      this.mode = mode
      const idB = bread.id
      const url = `${baseApiUrl}/bread-param/${idB}`
      axios.get(url).then(res => {
        this.bread = res.data
      })
      this.editBread = true
    },
    loadGrupoMenu () {
      const url = `${baseApiUrl}/grupo-de-menus-pa`
      axios.get(url).then(res => {
        this.grupoMenu = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.gp_nome}`
          }
        })
      })
    },
    loadSubMenuSite () {
      const id = this.gruponome
      const url = `${baseApiUrl}/menu-site-pa-grupo/${id}`
      axios.get(url).then(res => {
        this.subMenu = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.nome}`
          }
        })
      })
    },
    loadMenuSite () {
      const id = this.menunome
      const url = `${baseApiUrl}/subgrupo-de-menus-pa/${id}`
      axios.get(url).then(res => {
        this.parentMenu = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.nome}`
          }
        })
      })
    },
    loadMenuAdd () {
      const id = this.menupagina.uid_menu
      const url = `${baseApiUrl}/menu-site-pa-filtro/${id}`
      axios.get(url).then(res => {
        this.menupagina = res.data
        this.menupagina.usuario = this.user.id
        this.menupagina.uid_pagina = this.pagina.id
      })
    },
    addSair () {
      this.saveBread()
      this.addBread = false
    },
    addCont () {
      this.saveBread()
    },
    addSairMenu () {
      this.saveMenu()
      this.addMenus = false
    },
    addContMenu () {
      this.saveMenu()
    },
    loadInactiveMenu (item) {
      this.menupagina.id = item.id
      this.menupagina.inativar = true
      this.saveMenu()
    },
    loadActiveMenu (item) {
      this.menupagina.id = item.id
      this.menupagina.inativar = false
      this.saveMenu()
    },
    addDcSair () {
      this.saveDoc()
      this.addDoc = false
    },
    addDcCont () {
      this.saveDoc()
    },
    loadLink (link, mode = 'save') {
      this.mode = mode
      const idL = link.id
      const url = `${baseApiUrl}/link-param/${idL}`
      axios.get(url).then(res => {
        this.link = res.data
      })
      this.addLink = true
    },
    addLinkSair () {
      this.saveLink()
      this.addLink = false
    },
    addLinkCont () {
      this.saveLink()
    },
    undoBread () {
      const idB = this.bread.id
      this.bread = {}
      const url = `${baseApiUrl}/bread-param/${idB}`
      axios.get(url).then(res => {
        // eslint-disable-next-line no-return-assign
        return this.bread = res.data
      })
    },
    resetDoc () {
      this.doc = {}
      this.doc.usuario = this.user.id
      this.doc.uuid_pagina = this.pagina.uuid
      this.doc.uid_pagina = this.pagina.id
      this.doc.data_publicacao = ''
    },
    resetMidia () {
      this.midia = {}
      this.midia.usuario = this.user.id
      this.midia.uuid_pagina = this.pagina.uuid
      this.midia.uid_pagina = this.pagina.id
      this.midia.data_publicacao = ''
    },
    resetBread () {
      this.bread = {}
      this.bread.usuario = this.user.id
      this.bread.uuid_page = this.pagina.uuid
      this.bread.uid_page = this.pagina.id
    },
    resetMenu () {
      this.menupagina = {}
    },
    resetLink () {
      this.link = {}
      this.link.usuario = this.user.id
      this.link.uuid = uuid.v1()
      this.link.uuid_page = this.pagina.uuid
      this.link.uid_page = this.pagina.id
    },
    reset () {
      this.mode = 'save'
      this.foto = {}
      this.pagina = {}
      this.midias = []
      this.codigo = ''
      this.loadUser()
      this.loadDatas()
      this.pagina.uuid = uuid.v1()
    },
    loadDialog () {
      this.dialog = true
      this.loadPaginas()
    },
    loadAddDoc () {
      this.doc = {}
      this.doc.usuario = this.user.id
      this.doc.uuid_pagina = this.pagina.uuid
      this.doc.uid_pagina = this.pagina.id
      this.addDoc = true
    },
    loadAddMid () {
      this.midia = {}
      this.midia.usuario = this.user.id
      this.midia.uuid_pagina = this.pagina.uuid
      this.midia.uid_pagina = this.pagina.id
      this.addMidia = true
    },
    loadAddBread () {
      this.bread = {}
      this.bread.usuario = this.user.id
      this.bread.uuid_page = this.pagina.uuid
      this.bread.uid_page = this.pagina.id
      this.addBread = true
    },
    loadAddMenu () {
      this.menupagina = {}
      this.addMenus = true
      this.loadGrupoMenu()
    },
    closeDialogMenu () {
      this.resetMenu()
      this.addMenus = false
    },
    loadAddLink () {
      this.link = {}
      this.link.usuario = this.user.id
      this.link.uuid = uuid.v1()
      this.link.uuid_page = this.pagina.uuid
      this.link.uid_page = this.pagina.id
      this.loadCategorias()
      this.addLink = true
    },
    resetNode () {
      this.mode = 'save'
      this.publico = {}
      this.loadDatas()
    },
    loadPubConteudo () {
      //    this.publico.usuario = this.user.id //implementar na auditoria
      //    this.publico.uid_pagina = this.pagina.uuid // implementar na auditoria
      this.dateG()
      this.publicar = true
    },
    loadUser () {
      this.pagina.uuid = uuid.v1()
      this.pagina.usuario = this.user.id
      this.loadCategorias()
    },
    loadDatas () {
      const dataAgora = new Date().toISOString().substr(0, 10)
      this.data_criacao = moment(dataAgora).format('DD/MM/YYYY')
      this.date = dataAgora
      this.pagina.usuario = this.user.id
    }
    // (/menus-de-paginas-param)
    // (/menus-de-paginas-param/:id)
    // (/menus-de-paginas-param-update/:id)
    // `id`, `uid_pagina`, `uid_menu`, `chave`, `menu`, `ds_menu`, `posicao`, `inativar`, `created_at`, `updated_at`, `usuario` FROM `menupagina`
  },
  mounted () {
    this.loadUser()
  }
}
</script>

<style scoped>
.container {
  width: 98% !important;
}
</style>
